import { html, TemplateResult } from "lit";
import { DisplayRow, Favourite } from "../data/search-data";
import { newGuid } from "./view-consts";


const $j = $.fn as any;

export class FavouritesView {
    onChanged: () => void;
    favourites: Favourite[] = [];
    elementId: string;
    dataTable: any;
    onAddJob: (row: DisplayRow) => void;
    hasJobEvent: (windowId: string) => boolean;

    constructor(onChanged: () => void, addJobEvent: (row: DisplayRow) => void, hasJobEvent: (windowId: string) => boolean) {
        this.onChanged = onChanged;
        this.onAddJob = addJobEvent;
        this.hasJobEvent = hasJobEvent;
        this.elementId = 'fav-view-' + newGuid();
    }

    setFavourites(values: Favourite[]) {
        this.favourites = values;
        this.changed();
    }
    clear() {
        this.favourites = [];
        this.changed();
    }
    changed() {
        this.onChanged();
    }
    template(): TemplateResult {
        return html`
            <div id=${this.elementId}>
                <div>
                    <button @click=${() => this.clear()} class="btn btn-primary">Clear All</button>
                </div>
                <table class="data-table table cell-border table-striped" style="width:2590px">
                    <thead>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>`;
    }

    afterRender() {
        const jthis = $('#' + this.elementId);
        this.initializeDataTable(jthis);
    }
    private hasJob(windowId: string): boolean {
        if (this.hasJobEvent)
            return this.hasJobEvent(windowId);
        else
            return false;
    }
    private async initializeDataTable(jthis: any): Promise<void> {

        const $dataTable = jthis.find('.data-table') as any;
        const dataTableInitialized = $j.dataTable.isDataTable($dataTable);

        if (!dataTableInitialized) {
            const columns = [
                {
                    title: "Action",
                    width: "100px",
                    data: "windowId",
                    render: (value) => {
                        const addJobClass = (this.hasJob(value) ? "text-success" : "text-secondary");
                        return `<i class="act-remove text-danger fas fa-minus-square"></i> <i class="act-addjob fa fa-home ${addJobClass}" aria-hidden="true"></i>`;
                    }
                },
                {
                    title: "Window ID",
                    width: "120px",
                    data: "windowId"
                },
                {
                    title: "Manufacturer",
                    width: "250px",
                    data: "manufacturer"
                },
                {
                    title: "Frame Description",
                    width: "250px",
                    data: "frameDescription"
                },
                {
                    title: "Uw",
                    width: "120px",
                    data: "uw",
                    render: function (value) {
                        return value.toFixed(1);
                    }
                },
                {
                    title: "SHGCw",
                    width: "120px",
                    data: "shgc",
                    render: function (value) {
                        return value.toFixed(2);
                    }

                },
                {
                    title: "Tvw",
                    width: "120px",
                    data: "tvw"
                },
                {
                    title: "Ai",
                    width: "120px",
                    data: "ai"
                },
                {
                    title: "Operating Type",
                    width: "250px",
                    data: "operatingType"
                },
                {
                    title: "Frame Type",
                    width: "170px",
                    data: "frameType"
                },
                {
                    title: "Glass",
                    width: "200px",
                    data: "glazingDisplayName"
                },
                {
                    title: "Glass Supplier",
                    width: "250px",
                    data: "glassManufacturer"
                },
                {
                    title: "Cooling",
                    width: "120px",
                    data: "coolingStars",
                    render: function (value) {
                        return `<wers-stars value="${value}" type="cool"></wers-stars>`;
                    }
                },
                {
                    title: "Heating",
                    width: "120px",
                    data: "heatingStars",
                    render: function (value) {
                        return `<wers-stars value="${value}" type="heat"></wers-stars>`;
                    }
                },
                {
                    title: "Cool %", data: "coolingPercentage",
                    width: "120px",
                    render: function (value) {
                        return `<span class="text-primary">${value}%</span>`;
                    },

                },
                {
                    title: "Heat %", data: "heatingPercentage",
                    width: "120px",
                    render: function (value) {
                        return `<span class="text-danger">${value}%</span>`;
                    },

                }
            ];
            this.dataTable = $dataTable.DataTable({
                scrollX: true,
                scrollY: '50vh',
                scrollCollapse: true,
                paging: false,
                order: [[0, "asc"]],
                pageLength: 200,
                bLengthChange: false,
                processing: false,
                serverSide: false,
                data: this.favourites.map(x => x.displayRow),
                searching: false,
                info: false,
                columns: columns,
                fixedColumns: { left: 1 },
                autoWidth: false
            });
            let _this = this;
            this.dataTable.columns.adjust();
            $dataTable.on('click', 'i', (ev: Event) => {
                if (ev.target !== null) {
                    var data: DisplayRow = this.dataTable.row(($(ev.target) as any).parents('tr')).data();
                    if (data) {
                        //find the correct feature by testing attached classes on the buttons
                        if ((ev.currentTarget as HTMLElement).classList.contains("act-remove")) {
                            this.delFavourite(data);
                        } else if ((ev.currentTarget as HTMLElement).classList.contains("act-addjob")) {
                            this.addJob(data);
                            this.dataTable.rows().invalidate();
                        }

                    }
                }
            });
        } else {
            this.dataTable = $dataTable.DataTable();
            this.dataTable.columns.adjust();
            this.refreshGridData();
        }
    }
    addJob(data: any) {
        this.onAddJob(data);
    }

    public delFavourite(row: DisplayRow) {
        this.favourites = this.favourites.filter(x => x.displayRow.windowId !== row.windowId);
        this.changed();
    }

    addFavourite(row: DisplayRow) {
        this.favourites = [...this.favourites, { displayRow: row }];
        this.changed();
    }
    isFavourite(windowId: string): boolean {
        return this.favourites.some(f => f.displayRow.windowId === windowId);
    }

    public toggleFavourite(row: DisplayRow) {
        if (this.isFavourite(row.windowId)) {
            this.delFavourite(row);
        } else {
            this.addFavourite(row);
        }
    }
    private refreshGridData() {
        this.dataTable
            .clear()
            .rows
            .add(this.favourites.map(x => x.displayRow))
            .draw();
    }
}